export const coupon = {
    title: "ส่วนลด",
    all_coupon: "เลือกคูปอง",
    my_coupon: "คูปองของฉัน",
    use_now: "ใช้คูปองนี้",
    use: "ใช้",
    Used: "ใช้",
    crown_point: "คราวพอยท์",
    warning_point_not_enough: "คุณมีคะแนนคราวพอยท์ไม่เพียงพอ สะสม {0} คะแนนเพื่อแลกคูปองนี้",
    expire: "หมดอายุ : ",
    discount: "คูปองส่วนลด",
    bath: "บาท",
    promocode: {
        name: 'รหัสโปรโมชั่น',
        placeholder: 'รหัสโปรโมชั่น',
        required: 'กรอกรหัสโปรโมชั่น',
        too_short: '',
        invalid: '',
    },
    popup_confirm: {
        coupon: "Coupon : ",
        line2: "คะแนนคราวพอยท์ของคุณจะถูกหักทันทีหลังจากการยืนยัน",
        line3: 'ถ้าไม่ใช้ทันที คูปองจะไปอยู่ที่ "คูปองของฉัน"',
        confirm: 'ตกลง'
    },
    condition: 'เงื่อนไข',
    popup_condition: {
        coupon: 'คูปอง : ',
        condition: 'เงื่อนไข'
    }
};